import { AuditionFormRouteContext, GetAuditionContext } from 'pages/AuditionFormTop';
import { AuditionForm } from 'pages/u002/AuditionForm';
import { AuditionFormConfirm } from 'pages/u002/AuditionFormConfirm';
import { FC, useContext, useState } from 'react';
import AuditionFormCompleteModal from '../AuditionFormCompleteModal';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import { ApplyForm } from 'api/U002';
import { useNavigate } from 'react-router-dom';
import { PATHS } from 'commons/paths';
import { AuditionFormValues } from 'commons/auditionForm';

type PageState =
  | { page: 'AuditionForm' }
  | { page: 'AuditionFormConfirm'; applyForm: ApplyForm[]; values: AuditionFormValues };

/**
 * アンケートフォーム画面
 *
 */
export const QuestionnaireForm: FC = () => {
  const { audition_id, examination_no } = useContext(AuditionFormRouteContext);
  const { title } = useContext(GetAuditionContext);
  const { t } = useTranslationWithLang('auditionForm');
  const nav = useNavigate();

  // 初期ページ状態の設定
  const [pageState, setPageState] = useState<PageState>({ page: 'AuditionForm' });
  //完了モーダルの状態
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* 応募フォーム */}
      {pageState.page === 'AuditionForm' && (
        <AuditionForm
          title={title}
          audition_id={audition_id}
          examination_no={examination_no}
          onNext={(param) =>
            setPageState({
              page: 'AuditionFormConfirm',
              applyForm: param.applyForm,
              values: param.values,
            })
          }
        />
      )}

      {/* 応募フォーム確認画面 */}
      {pageState.page === 'AuditionFormConfirm' && (
        <AuditionFormConfirm
          title={title}
          audition_id={audition_id}
          examination_no={examination_no}
          applyForm={pageState.applyForm}
          values={pageState.values}
          onSuccess={() => setIsOpen(true)}
          onBack={() => setPageState({ page: 'AuditionForm' })}
        />
      )}

      {/* 完了モーダル */}
      {isOpen && (
        <AuditionFormCompleteModal
          end_custom_txt={t('TU002_122')}
          onClose={() => {
            setIsOpen(false);
            nav(PATHS.MYPAGE);
          }}
          closeLabel={t('TU002_039')}
        />
      )}
    </>
  );
};
